export const scopedViewsActions = {
  CLICK_SCOPED_VIEW_ADMIN_MUTE: "CLICK_SCOPED_VIEW_ADMIN_MUTE",
  CLICK_SCOPED_VIEW_MODAL_CREATED: "CLICK_SCOPED_VIEW_MODAL_CREATED",
} as const;
